export interface AccessClaims {
  sub: string;
  email: string;
  roles?: string[];
  exp?: number;
}

/** Decode (NOT verify) a JWT payload. The server verifies; the client only
 *  reads sub+email to populate the session user. Returns null if malformed. */
export function decodeJwt(token: string): AccessClaims | null {
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(b64.padEnd(b64.length + ((4 - (b64.length % 4)) % 4), '='));
    const payload = JSON.parse(json) as Record<string, unknown>;
    if (typeof payload.sub !== 'string' || typeof payload.email !== 'string') return null;
    return {
      sub: payload.sub,
      email: payload.email,
      roles: Array.isArray(payload.roles) ? (payload.roles as string[]) : undefined,
      exp: typeof payload.exp === 'number' ? payload.exp : undefined,
    };
  } catch {
    return null;
  }
}
